<template lang="html">
	<div class="button_multiple">
		<div class="left">
			<el-button type="primary" size="mini" icon="el-icon-plus" v-if="hasBtn('sys:'+model+':add')" @click="$emit('click_add')">添加</el-button>
			<el-button type="danger" size="mini" icon="el-icon-delete" v-if="hasBtn('sys:'+model+':dall')" @click="$emit('click_dall')">删除</el-button>
			<upload_import v-if="hasBtn('sys:'+model+':import')" :action="action || model+'/import'" :name="import_name" @change="$emit('click_init')">导入</upload_import>
			<el-button type="success" size="mini" icon="el-icon-download" v-if="hasBtn('sys:'+model+':export')" @click="$emit('export_click')">导出</el-button>
			<el-button type="" size="mini" v-if="hasBtn('sys:'+model+':expand')" @click="$emit('click_toggle_all',true)">展开全部</el-button>
			<el-button type="" size="mini" v-if="hasBtn('sys:'+model+':collapse')" @click="$emit('click_toggle_all',false)">折叠全部</el-button>
			<slot name="left"></slot>
		</div>
		<div class="right">
			<slot name="right"></slot>
			<el-button type="" size="mini" icon="el-icon-refresh" @click="$emit('click_init')"></el-button>
			<el-button type="" size="mini" icon="el-icon-full-screen" @click="$emit('click_full')"></el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'buttonCollection',
	data() {
		return {}
	},
	props: {
	    model: {
			type: String,
			default: ''
	    },
	    action: {
			type: String,
			default:''
	    },
	    import_name: {
			type: String,
			default: 'file'
	    }
	},
	mounted: function() {
		// console.log(this.action)
	},
	methods: {
	}
}
</script>
<style lang="css">

</style>



// WEBPACK FOOTER //
// src/components/buttonCollection.vue